<template>
  <v-dialog v-model="model" max-width="600">
    <v-card class="k-card pa-4">
      <div class="d-flex align-center mb-2">
        <div>
          <div class="text-h6 font-weight-bold">{{ $t("groups.inviteTitle") }}</div>
          <div style="opacity:.75">{{ $t("groups.shareLink") }}</div>
        </div>
        <v-spacer />
      </div>

      <v-text-field
        :value="link"
        outlined
        dense
        readonly
        append-icon="mdi-content-copy"
        @click:append="copy"
      />

      <v-alert v-if="copied" type="success" dense text>{{ $t("common.copied") }}</v-alert>

      <div class="d-flex justify-end">
        <v-btn text @click="model=false">{{ $t("common.close") }}</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: { value: Boolean, link: { type: String, default: "" } },
  data: () => ({ copied: false }),
  computed: {
    model: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); }
    }
  },
  methods: {
    async copy() {
      try {
        await navigator.clipboard.writeText(this.link);
        this.copied = true;
        setTimeout(() => (this.copied = false), 1200);
      } catch (e) {
        alert(this.$t("groups.copyError"));
      }
    }
  }
};
</script>
